import * as React from 'react';
export const IcTimezone = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.65 17a.509.509 0 00-.56.2l-1 1.44a.5.5 0 000 .56l1 1.55a.481.481 0 00.42.23h.14a.5.5 0 00.35-.48v-3a.5.5 0 00-.35-.5zM22 12a10.1 10.1 0 00-.76-3.83A10 10 0 009.099 2.427a10 10 0 00-4.17 16.643 9.93 9.93 0 009.82 2.53A4.93 4.93 0 0114 19a5 5 0 015-5 4.91 4.91 0 012.6.75A9.777 9.777 0 0022 12zm-9 1a1 1 0 01-1 1H9a1 1 0 010-2h2V9a1 1 0 012 0v4zm7.92 4.23a.5.5 0 00-.92.27v3a.5.5 0 00.35.48h.15a.491.491 0 00.41-.22l1-1.44a.5.5 0 000-.56l-.99-1.53z'
      fill='currentColor'
    />
  </svg>
);
